module.exports = __webpack_public_path__ + "static/img/cera.c41d70b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cera.jpeg
// module id = sN2h
// module chunks = 1